function connectWS(userId, onOpen, onClose, onMessage) {
  const isLocal = (window.location.href.indexOf("localhost") > -1);
  const host = isLocal ? "http://localhost:8080" : "";
  const sock = new window.SockJS(`${host}/v1/ws/ghostpines/connect?userId=${userId}`);
  sock.onopen = (e) => {
    // console.log(e);
    onOpen && onOpen(e);
  };
  sock.onclose = (e) => {
    // console.log(e);
    onClose && onClose(e);
  };
  sock.onmessage = (e) => {
    // console.log(e);
    onMessage && onMessage(e);
  };
  sock.onerror = (e) => {
    console.log(e);
  };

  return sock;
}

export { connectWS };
